import makeStyles from '@material-ui/core/styles/makeStyles';
import Chip from '@material-ui/core/Chip';
import Check from '@material-ui/icons/Check';
import ReportProblemOutlined from '@material-ui/icons/ReportProblemOutlined';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import Close from '@material-ui/icons/Close';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(theme => {
  const colors = theme.palette;

  return {
    root: {
      borderRadius: '0',
      height: '45px',
      width: '100%',
      '& .MuiChip-avatar': {
        color: colors.white,
        height: '45px',
        width: '45px',
        marginLeft: '0',
        padding: '5px'
      },
      '& .MuiChip-label': {
        margin: '0 10px 0 5px',
        flexGrow: '1',
        whiteSpace: 'break-spaces'
      }
    },
    info: {
      backgroundColor: colors.primary.light,
      '&:focus': {
        backgroundColor: colors.primary.light
      },
      '& .MuiChip-avatar': {
        backgroundColor: colors.primary.main
      },
      '& .MuiChip-deleteIcon': {
        color: colors.primary.main
      }
    },
    success: {
      backgroundColor: colors.secondary.light,
      '&:focus': {
        backgroundColor: colors.secondary.light
      },
      '& .MuiChip-avatar': {
        backgroundColor: colors.secondary.main
      },
      '& .MuiChip-deleteIcon': {
        color: colors.secondary.main
      }
    },
    error: {
      backgroundColor: colors.error.light,
      '&:focus': {
        backgroundColor: colors.error.light
      },
      '& .MuiChip-avatar': {
        backgroundColor: colors.error.main
      },
      '& .MuiChip-deleteIcon': {
        color: colors.error.main
      }
    }
  };
});

const typeIconMap = {
  info: <InfoOutlined />,
  error: <ReportProblemOutlined />,
  success: <Check />
};

const Message = ({ type, text, onClose }) => {
  const classes = useStyles();

  return (
    <Chip
      className={`${classes.root} ${classes[type] || classes.info}`}
      size="medium"
      avatar={typeIconMap[type]}
      label={text}
      onDelete={onClose}
      deleteIcon={<Close />}
    />
  );
};

Message.propTypes = {
  type: PropTypes.oneOf(['info', 'error', 'success']).isRequired,
  text: PropTypes.string.isRequired,
  onClose: PropTypes.func
};

Message.defaultProps = {
  onClose: null
};

export default Message;
